'use strict';

var Color = require('color');

var functionsToMap = ['darken', 'lighten', 'lightness'];
var functions = {};

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  var _loop = function _loop() {
    var key = _step.value;

    functions[key] = function (color, amount) {
      return Color(color)[key](amount).hexString();
    };
  };

  for (var _iterator = functionsToMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    _loop();
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

module.exports = functions;